var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ComponentsCardContainer',[(!_vm.error)?_c('List',{attrs:{"data":_vm.machines,"headers":_vm.headers,"is-loading":_vm.loading}}):_vm._e(),(_vm.error)?_c('v-alert',{attrs:{"type":"error"}},[_vm._v(" "+_vm._s(this.error)+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }